import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteAccountSuccessComponent } from './delete-account-success.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [DeleteAccountSuccessComponent],
  imports: [CommonModule, TranslateModule],
  exports: [DeleteAccountSuccessComponent],
  providers: [LocalizationService, TranslateModule],
})
export class DeleteAccountSuccessModule {}
